export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-01.0f7610ca.jpg";